module.exports = __webpack_public_path__ + "img/safety-management-item3-1.00f9b075.png";